import actions from "./actions.js";
import mutations from "./mutations.js";

export const initialState = () => {
  return {
    showDialog: false,
    dialogTitle: "Title",
    dialogText: "Text",
    cancelText: "Cancel",
    maxWidth: null,
    onSelection: () => {},
    onCancel: () => {},
    resolve: null,
    selection: ["a"],
    hasFilter: false,
    icon: undefined,
    layer: 0
  };
};

export const buttonSelectionDialogModule = {
  state: initialState(),
  namespaced: true,
  getters: {},
  actions,
  mutations
};
